const daMessages = {
  /* 01.General */
   "main.name": "Navn",
  "main.sentiment": "Følelse",
  "main.urgency": "Hastende",
  "main.language": "Sprog",
  "main.agent": "Agent",
  "main.property_name": "Ejendommens navn",
  "main.booking_number": "Bookingnummer",
  "main.check_out": "Udtjekning",
  "main.check_in": "Indtjekning",
  "main.adults": "Voksne",
  "main.corporate_code": "Virksomhedskode",
  "main.group_code": "Gruppekode",
  "main.promo_code": "Promokode",
  "main.ai_response": "AI-svar",
  "main.template_response": "Skabelonsvar",
  "main.converttoticket": "Konverter til billet",
  "main.switch_property": "Skift ejendom",
  "main.Group_id": "Gruppe-ID",
  "main.integration_id": "Integrations-ID",
  "main.submit": "Indsend",
  "main.cancel": "Annuller",
    "main.select_template": "Vælg en skabelon",
  "main.rooms": "Værelser",
  "main.rates": "Priser",

  //footer
    "footer.knowledge": "Viden",
  "footer.home": "Hjem",
  "footer.help": "Hjælp",

  //ticket

  "ticket.thank_you": "Tak for at indsende formularen",
  "ticket.ticket": "Billet",
  "ticket.details": "Udfyld formularen med oplysninger om billetten.",
  "ticket.select_category": "Vælg kategori",
  "ticket.category": "Kategori",
  "ticket.title": "Titel",
  "ticket.notes": "Noter",
  "ticket.status": "Status",
  "ticket.assigned_to": "Tildelt til",
  "ticket.submit_form": "Indsend formular",

  
  "main.total": "Total",
  "main.pastetooutlook": "Indsæt i Outlook",
  "main.children": "Børn",
  "main.promocode": "Promo-/Virksomheds-/Gruppekode",
  "main.exact_match_only": "Kun nøjagtigt match",
  "main.search": "Søg",
  "main.no_rate_match": "Ingen priser matcher dit valg. Rediger din søgning, og prøv igen.",
  "main.translate_to": "Oversæt til",
  "main.regenerate": "Generer igen",
  "main.copy_text": "Kopiér tekst",
  "main.additional_instructions": "Yderligere instruktioner",

  "faq.helpcenter": "Hjælpecenter",
  "faq.reply.email.sabre.question": "Hvordan svarer jeg på en e-mail ved hjælp af Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Åbn e-mailen, og start Aven Hospitality-tilføjelsesprogrammet. Du kan vælge mellem tre muligheder: bruge en foruddefineret skabelon, generere et AI-svar eller konvertere e-mailen til en billet. Vælg den mulighed, der passer bedst, gennemgå svaret, foretag ændringer om nødvendigt, og send direkte fra Outlook.",

  "faq.rates.availability.question": "Hvordan tilføjer jeg priser, tilgængelighed og værelsesoplysninger til mit svar?",
  "faq.rates.availability.answer": "Brug funktionen + Rates til at indtaste gæsteoplysninger såsom datoer og antal gæster. Concierge indsætter nøjagtig tilgængelighed og priser i dit svar. Du kan også bruge + Rooms til at inkludere værelsesbeskrivelser og billeder.",

  "faq.different.language.question": "Hvad skal jeg gøre, hvis e-mailen er på et andet sprog?",
  "faq.different.language.answer": "Aven Hospitality Concierge giver dig mulighed for at oversætte indgående e-mails til dit foretrukne sprog.",

  "faq.pin.addin.question": "Hvordan sikrer jeg, at tilføjelsesprogrammet altid er tilgængeligt i Outlook?",
  "faq.pin.addin.answer": "Fastgør Aven Hospitality Concierge-tilføjelsesprogrammet i Outlook, så det altid er synligt.",

  "faq.knowledge.hub.question": "Hvad er Knowledge Hub-søgefunktionen?",
  "faq.knowledge.hub.answer": "Knowledge Hub-søgning hjælper dig med hurtigt at finde ejendomsspecifikke oplysninger direkte i Outlook.",

  "faq.reply.email.myma.question": "Hvordan svarer jeg på en e-mail ved hjælp af Myma?",
  "faq.reply.email.myma.answer": "Åbn e-mailen, og start Myma-tilføjelsesprogrammet. Du kan bruge en skabelon, generere et AI-svar eller konvertere e-mailen til en billet.",

  "faq.room.details.question": "Hvordan tilføjer jeg værelsesoplysninger til mit svar?",
  "faq.room.details.answer": "Brug + Rooms til at inkludere værelsesbeskrivelser og billeder.",

  "faq.myma.different.language.question": "Hvad skal jeg gøre, hvis e-mailen er på et andet sprog?",
  "faq.myma.different.language.answer": "Myma giver dig mulighed for at oversætte indgående e-mails til dit foretrukne sprog.",

  "faq.myma.pin.addin.question": "Hvordan sikrer jeg, at tilføjelsesprogrammet altid er tilgængeligt i Outlook?",
  "faq.myma.pin.addin.answer": "Fastgør Myma-tilføjelsesprogrammet i Outlook, så det åbnes automatisk med hver e-mail.",

};

export default daMessages;
